import React, { useState } from 'react';
import UserIcon from '@design-system/Assets/UserIcon';
import UserplusIcon from '@design-system/Assets/UserplusIcon';
import AkaaniLogo from '@design-system/Assets/Alogosmallgreen';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import hamburger from '@design-system/Assets/Hamburger.svg';
import PropTypes from 'prop-types';

export default function Header({ active }) {
  const [mobileNavVisible, setMobileNavVisible] = useState(false);

  const toggleMobileNav = () => {
    setMobileNavVisible(!mobileNavVisible);
  };
  return (
    <div>
      <header className="landing-header">
        <AkaaniLogo />

        <button className="lg:hidden" onClick={toggleMobileNav}>
          <img src={hamburger} />
        </button>

        <ul className="lg:flex flex-row gap-5 hidden">
          <li>
            <Link className={`${active == 'home' ? 'text-ak100' : ''}`} to="/">
              Home
            </Link>
          </li>
          <li>
            <Link
              className={`${active == 'marketplace' ? 'text-ak100' : ''}`}
              to="/marketplace"
            >
              MarketPlace
            </Link>
          </li>
          <li>
            <Link to="/">For Sellers</Link>
          </li>
        </ul>

        <div className=" gap-8 items-center hidden lg:flex">
          <Link to="/login" className="flex flex-row gap-2 items-center">
            <UserIcon />
            Login
          </Link>
          <Link
            to="/signup"
            className="bg-ak100 px-6 py-3 text-white text-center rounded-md w-full flex flex-row gap-3 font-bold items-center"
          >
            <UserplusIcon />
            Sign Up
          </Link>
        </div>
      </header>
      {mobileNavVisible && (
        <div className="lg:hidden transition-transform duration-500 ease-in-out text-center mb-4">
          <ul>
            <li>
              <Link className={`${active == 'home' ? 'text-ak100' : ''}`} to="/home">
                Home
              </Link>
            </li>
            <li className="my-1">
              <Link
                to="/marketplace"
                className={`${active == 'marketplace' ? 'text-ak100' : ''}`}
              >
                MarketPlace
              </Link>
            </li>
            <li>
              <a href="https://useakaani.com/sella.html">For Sellers</a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

Header.propTypes = {
  active: PropTypes.string.isRequired,
};
